import { render, staticRenderFns } from "./game.vue?vue&type=template&id=69203f40&scoped=true"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"
import style0 from "./game.vue?vue&type=style&index=0&id=69203f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69203f40",
  null
  
)

export default component.exports